import React from 'react';
import { arrayOf, shape } from 'prop-types';
import DropdownAudio from '../DropdownAudio';
import { useFormularDenuncia } from '../../context/formularDenuncia.context';

import renderContent from './renderContent';

const DatosComunicacion = ({ data }) => {
  const { control, formState, adjuntarAudio, audioAdjuntado } = useFormularDenuncia();

  return (
    <div className="u-mt-24">
      <h2>Datos de la comunicación</h2>
      <p className="u-mt-16">
        A continuación, puede completar el siguiente formulario con los detalles de la denuncia, o bien puede incluir un
        documento de audio detallando los motivos de su denuncia. Si lo desea, puede realizar ambas acciones.
      </p>
      <div className="o-grid u-mt-16">
        <div className="o-grid__row">
          <div className="o-grid__col-12">
            <DropdownAudio defaultValue={audioAdjuntado?.name} onSelect={adjuntarAudio} />
          </div>
        </div>
        {renderContent(data, control, formState)}
      </div>
    </div>
  );
};
DatosComunicacion.propTypes = {
  data: arrayOf(arrayOf(shape({}))),
};
DatosComunicacion.defaultProps = {
  data: [],
};

export default DatosComunicacion;
